import r from"js-cookie";var e=function(){return r.get("access_token")},n=function(){var r=e();return r?"Bearer ".concat(r):null};export{n as getFullToken,e as getToken};
